<script setup lang="ts">
import { type BadgeSeverity, type BadgeSize, type BadgeBehaviour, severitySwitch, getSizeSet } from '../../composables/useBadgeStyles';
import { computed, toRefs } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  severity: {
    type: String as () => BadgeSeverity,
    default: 'primary',
  },
  size: {
    type: String as () => BadgeSize,
    default: 'sm',
  },
  behaviour: {
    type: String as () => BadgeBehaviour,
    default: 'static',
  }
});

const { label, severity, size } = toRefs(props);

const severityClasses = computed(() => severitySwitch(severity.value));
const sizeClasses = computed(() => {
  const sizeSet = getSizeSet(size.value, props.behaviour);
  return {
    label: sizeSet.label,
    sizing: sizeSet.size,
  };
});

const badgeClasses = computed(() => {
  return [
    'rounded-full font-bold items-center justify-center',
    sizeClasses.value.label,
    sizeClasses.value.sizing,
    severityClasses.value,
  ];
});
</script>

<template>
  <span
    class="font-roboto-slab flex"
    :class="badgeClasses"
  >
    <template v-if="size !== 'xs'">
      {{ label }}
    </template>
  </span>
</template>
